import React from "react";
import verified from '../Images/Verified.png'
import { MdEmail } from "react-icons/md";
import { MdPhone } from "react-icons/md";
import { MdLocationOn } from "react-icons/md";
import { motion } from "framer-motion";


const Secone = () => {

    const background ={
        background: '#EEEE',
    }
    const glideUp = {
        initial: { opacity: 0, y: 60 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.7 },
        viewport: { once: true }
    };

    return(
        <>
          <div style={background}>
          <div className="container py-5">
            
            <div className="row top">

              <div className="col-12">
                
                <h1 className="fw-bold  mb-3">
                  Ready to scale your <span style={{color: '#F29235'}}>digital infrastructure?</span>
                </h1>

                <p className="fs-5 mb-5">
                  Our experts are ready to help Chilicom Technologies’ partners achieve their digital goal.
                </p>
              </div>

              <div className="col-md-6">
                <motion.div
                  {...glideUp}
                  className="p-4 d-flex gap-3 shadow-lg rounded-4 bg-white mb-4"
                  whileHover={{
                    y: -10, // smooth lift
                    scale: 1.02,
                    boxShadow: "0 0 20px rgba(242,146,53,0.6), 0 20px 30px rgba(0,0,0,0.15)" // glow + shadow
                  }}
                  transition={{ type: "spring", stiffness: 100, damping: 15 }} // smooth animation
                >
                  <MdEmail 
                    style={{
                      background: '#F4F4F4',
                      padding: '10px',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease'
                    }}
                    size={60}
                    color="#F29235"
                  />
                  <div>
                    <h5 className="fw-bold">Email Us</h5>
                    <p className="mb-0">chilicomtech.com.ng</p>
                  </div>
                </motion.div>
                <motion.div
                  {...glideUp}
                  className="p-4 d-flex gap-3 shadow-lg rounded-4 bg-white mb-4"
                  whileHover={{
                    y: -10, // smooth lift
                    scale: 1.02,
                    boxShadow: "0 0 20px rgba(242,146,53,0.6), 0 20px 30px rgba(0,0,0,0.15)" // glow + shadow
                  }}
                  transition={{ type: "spring", stiffness: 100, damping: 15 }} // smooth animation
                >
                  <MdEmail 
                    style={{
                      background: '#F4F4F4',
                      padding: '10px',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease'
                    }}
                    size={60}
                    color="#F29235"
                  />
                  <div>
                    <h5 className="fw-bold">Call Us</h5>
                    <p className="mb-0">+234 80 9836 2217</p>
                  </div>
                </motion.div>
                <motion.div
                  {...glideUp}
                  className="p-4 d-flex gap-3 shadow-lg rounded-4 bg-white mb-4"
                  whileHover={{
                    y: -10, // smooth lift
                    scale: 1.02,
                    boxShadow: "0 0 20px rgba(242,146,53,0.6), 0 20px 30px rgba(0,0,0,0.15)"
                  }}
                  transition={{ type: "spring", stiffness: 100, damping: 15 }}
                >
                  <MdEmail 
                    style={{
                      background: '#F4F4F4',
                      padding: '10px',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease'
                    }}
                    size={60}
                    color="#F29235"
                  />
                  <div>
                    <h5 className="fw-bold">Visit Us</h5>
                    <p className="mb-0">Block 17, Flat 1, Onilegogoro estate, off Masha Rd</p>
                  </div>
                </motion.div>

                  <motion.div {...glideUp} className="p-5 shadow-lg rounded-4 mb-4">
                  <div className="d-flex gap-2">
                  <div>
                  <img src={verified} alt="" />
                  </div>
                  <div>
                  <h4 className="fw-bold mt-3">Guaranteed Response</h4>
                  </div>
                  </div>

                  <p className="mb-4 mt-3">
                  Our solutions architect team typically responds to all B2B inquiries within 24 business hours.
                  </p>

                  </motion.div>

              </div>

              <div className="col-md-6">
                <div className="bg-white p-4 p-md-5   shadow-lg rounded-4">
                          <h4 className="mb-4 fs-3 fw-bold">Send an inquiry</h4>

                          <form>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                <label className="form-label fs-5">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your name"
                                />
                                </div>

                                <div className="col-12 col-md-6 mb-3">
                                <label className="form-label fs-5">Work Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="ololatch@company.com"
                                />
                                </div>

                                <div className="col-12 col-md-6 mt-4">
                                <label className="form-label fs-5">Company Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="olola Inc."
                                />
                                </div>

                              <div className="col-12 col-md-6 mt-4">
                                <label className="form-label fs-5">Service Interest</label>
                                <select className="form-select">
                                    <option value="">Select a service</option>
                                    <option value="cloud">UI/UX Design</option>
                                    <option value="cybersecurity">Backend Engineering</option>
                                    <option value="devops">SEO Optimization</option>
                                    <option value="networking">E-commerce</option>
                                    <option value="consulting">API Integration</option>
                                    <option value="consulting">Performance Tuning</option>
                                </select>
                                </div>


                                <div className="col-12 mt-5">
                                <label className="form-label fs-5">How can we help?</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Tell us about your projects or requirements..."
                                ></textarea>
                                </div>
                              <div className="col-12 mt-4">

                                {/* Checkbox */}
                                <div className="form-check text-center agreement-text">
                                  <input className="form-check-input" type="checkbox" id="agreeCheck" />
                                  <label className="form-check-label" htmlFor="agreeCheck">
                                    I agree to the{" "}
                                    <a href="/terms" target="_blank" rel="noopener noreferrer">
                                      Terms & Conditions
                                    </a>{" "}
                                    and{" "}
                                    <a href="/privacy" target="_blank" rel="noopener noreferrer">
                                      Privacy Policy
                                    </a>
                                  </label>
                                </div>

                                {/* Button */}
                                <div className="d-grid mt-3">
                                  <button className="butt w-100">Send Message</button>
                                </div>

                              </div>

                            </div>
                            </form>
                    </div>
                    
                      </div>
      </div>

    </div>

       
       
    </div>
        </> 
    )
}

export default Secone;
                
    
